/** @format */
'use client';
import ModalTrigger from '@atoms/ModalTrigger';
import { TableKey } from '@common/application/enums/TableKey';
import { TableConfig } from '@common/application/hooks/useDefaultSettings';
import useDefaultSettings from '@common/application/hooks/useDefaultSettings/useDefaultSettings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PopupBody from '@molecules/PopupBody/PopupBody';
import SettingsButtons from '@molecules/SettingsButtons';
import TableSettingsControls from '@molecules/TableSettingsControls';
import React from 'react';

interface TableSettingsModalProps {
  settings: TableConfig;
  setSettings(val: any): void;
  saveChanges(successCallback?: () => void): Promise<any>;
  undoChanges(): void;
  tableKey: TableKey;
}

function TableSettingsModalTrigger(props: TableSettingsModalProps) {
  const defaultSettings = useDefaultSettings().tableSettings[props.tableKey];

  return (
    <ModalTrigger title={'Edit Table Settings'} button={<FontAwesomeIcon icon={['fas', 'gear']} />}>
      {(close) => (
        <PopupBody>
          <TableSettingsControls settings={props.settings} setSettings={props.setSettings} settingsKey={props.tableKey} undoChanges={props.undoChanges} />
          <SettingsButtons
            onSave={async () => {
              await props.saveChanges(close);
            }}
            onResetToDefault={() => props.setSettings({ [props.tableKey]: defaultSettings })}
            onCancel={() => {
              props.undoChanges();
              close();
            }}
          />
        </PopupBody>
      )}
    </ModalTrigger>
  );
}

export default TableSettingsModalTrigger;
